import Table from '../../components/ui/Table'
import { formatCurrency, formatDate } from '../../lib/format'

function ExpenseTable({ expenses }) {
  if (!expenses.length) {
    return <div className="text-muted">No expenses match the current filters.</div>
  }

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Header>Date</Table.Header>
          <Table.Header>Product</Table.Header>
          <Table.Header>Category</Table.Header>
          <Table.Header>Vendor</Table.Header>
          <Table.Header className="text-right">Amount</Table.Header>
          <Table.Header>Notes</Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {expenses.map(expense => (
          <Table.Row key={expense.id}>
            <Table.Cell>{formatDate(expense.date)}</Table.Cell>
            <Table.Cell>{expense.products?.name || '—'}</Table.Cell>
            <Table.Cell>{expense.category}</Table.Cell>
            <Table.Cell>{expense.vendor || '—'}</Table.Cell>
            <Table.Cell className="text-right">{formatCurrency(expense.amount)}</Table.Cell>
            <Table.Cell>{expense.notes || '—'}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}

export default ExpenseTable
